import React from 'react';

import HeroSection from '../sections/HeroSection/HeroSection';
import BasicSection from '../sections/BasicSection/BasicSection';
import DescriptionSection from '../sections/DescriptionSection/DescriptionSection';
import AddressAllegroSection from '../sections/AddressAllegroSection/AddressAllegroSection';

const FAQ = () => (
    <React.Fragment>
        <HeroSection image="./assets/faq_banner.jpg" />
        <BasicSection
            title="format pliku"
            image="./assets/big_pdf.png"
            theme="black"
            rightColumn={
                <div>
                    <p>Zalecamy format: PDF w standardzie PDFx/1a:2001</p>
                    <p>Akceptowane formaty:<br/>EPS, TIFF, JPG.</p>
                    <p>Wszystkie teksty w projekcie powinny być zamienione na krzywe.</p>
                    <p>Rozdzielczość zdjęć i grafik umieszczonych w pliku 300 DPI.</p>
                </div>
            }
        />
        <BasicSection
            title="kolorystyka"
            image="./assets/big_cmyk.png"
            theme="blue"
            rightColumn={
                <div>
                    <p>Pracę należy przygotować w przestrzeni kolorystycznej CMYK. Jeżeli występują w pracy obrazy rastrowe (grafiki, fotografie) należy je również zamienić na CMYKa.</p>
                    <p>Nie należy mieszać różnych przestrzeni barwnych lub modeli kolorów w jednym dokumencie (np. CMYK i RGB) doprowadzi do błędnego odwzorowania kolorów i nie podlega reklamacji.</p>
                    <p>Istnieje możliwość wystąpienia różnic w kolorach w porównaniu do wydruków z drukarek oraz obrazu wyświetlanego na monitorze ze względu na różnice w technologii druku i prezentacji barw.</p>
                </div>
            }
        />
        <BasicSection
            title="spad"
            image="./assets/big_spad.png"
            theme="white"
            rightColumn={
                <div>
                    <p><b>Spad</b> jest to  obszar projektu „wychodzący” poza linię cięcia.</p>
                    <p>Wymiar etykiety powinien być większy od finalnego rozmiaru o 2 mm z każdej strony.</p>
                    <p>Spady są niezbędne, aby zminimalizować błędy przesunięcia przy wycinaniu.</p>
                </div>
            }
        />
        <BasicSection
            title="linia cięcia"
            image="./assets/big_ciecie.png"
            theme="white"
            rightColumn={
                <div>
                    <p><b>Linia Cięcia</b> to linia po której ma zostać wycięta etykieta.</p>
                    <p>Linię cięcia pojedynczej etykiety należy stworzyć z jednej zamkniętej krzywej w kolorze czarnym 100% i zapisać na drugiej stronie pliku pdf.</p>
                    <p>Przy dowolnych kształtach etykiety, należy zminimizować liczbę wierzchołków krzywej.</p>
                    <p>W przypadku dużej ilości wierzchołków, wycięcie etykiety może okazać się niemożliwe.</p>
                    <p>Narożniki lini cięcią powinny być zaaokrąglone do promienia minimum 1mm.</p>
                </div>
            }
        />
        <BasicSection
            title="bezpieczny margines"
            image="./assets/big_margines.png"
            theme="white"
            rightColumn={
                <div>
                    <p><b>Bezpieczny margines.</b></p>
                    <p>Wszystkie istotne elementy, (logo, teksty) powinny zostać umieszczone w bezpiecznej odległości od krawędzi etykiety (minimum 2mm).</p>
                </div>
            }
        />
        <BasicSection
            title="spad, linia cięcia, margines"
            image="./assets/big_spad_linia_margines.png"
            theme="white"
            rightColumn={
                <div>
                    <div><b className="belt pink"></b> <b>Spad</b></div>
                    <div><b className="belt blue"></b> <b>Linia cięcia</b></div>
                    <div><b className="belt green"></b> <b>Bezpieczny margines</b></div>
                </div>
            }
        />
        <BasicSection
            title="brutto... netto..."
            image="./assets/big_spad_linia_margines.png"
            theme="white"
            leftColumn={
                <div>
                    <img className="full-image d-none d-md-block" alt="" src="./assets/big_netto.png"/>
                    <div className="text-center">
                        <b>Przygotowany plik ze spadem,</b>
                        <p>- format brutto + 2 mm spadu z każdej strony.</p>
                    </div>
                </div>
            }
            rightColumn={
                <div>
                    <img className="full-image d-none d-md-block" alt="" src="./assets/big_brutto.png"/>
                    <div className="text-center">
                        <b>Finalna etykieta po wycięciu,</b>
                        <p>- format netto bez spadu.</p>
                    </div>
                </div>
            }
        />
        <BasicSection
            title="10 x NIE"
            theme="blue"
            leftColumn={
                <div>
                    <p>Nie dodawaj lini cięcią na projekcie (szczególnie w plikach: JPG i TIF; w plikach pdf, eps, możesz zapisać linię cięcią na nowej warstwie lub dodać kolejną stronę z samym wykrojnikiem.</p>
                    <p>Nie przyjmujemy plików pdf wygenerowanych z programów biurowych.</p>
                    <p>Nie drukujemy w RGB.</p>
                    <p>Nie ponosimy odpowiedzialnoiści za wydruk z plików przygotowanych w niskiej rozdzielczości (poniżej 300DPI)</p>
                    <p>Nie dodawaj znaczników drukarskich do projektu.</p>
                </div>
            }
            rightColumn={
                <div>
                    <p>Nie rasteryzuj: tekstów i kodów kreskowych.</p>
                    <p>Nie stosuj mniejszego rozmiaru fontu niż: na jasnych tłach 4,7 pkt, a na ciemnych 5 pkt. </p>
                    <p>Nie umieszczaj istotnych obiektów (zdjęć, grafik, tekstów) w odleglości mniejszej niż 2 mm od krawędzi etykiety.</p>
                    <p>Nie przyjmujemy plików CDR.</p>
                    <p>Nie używaj w projekcie atrybutu Overprint (nadruk).</p>
                </div>
            }
        />
        <DescriptionSection
            imageButton="./assets/phone-link.png"
            imageLink="/#contact-form"
        >
            <React.Fragment>
                <h4>Masz jakieś pytania<br /><b>- sprawdź FAQ.</b></h4>
                <h4>
                    Jeśli nie znalazłeś odpowiedzi<br />-
                    <b>skontaktuj się z nami.</b>
                </h4>
            </React.Fragment>
        </DescriptionSection>
        <AddressAllegroSection/>
    </React.Fragment>
);

export default FAQ;